import React from 'react';
import { connect, useDispatch } from 'react-redux';

import * as _ from 'lodash';
import DatagridRowGroupBond from './DatagridRowGroupBond';

function DataGridGroupBond(props) {
  const { isPc, resource, children, className } = props;

  console.log(resource);

  return (
    <table className={className + ''}>
      <colgroup>
        <col width="6%" />
        <col width="2.5%" />
        <col width="2.5%" />
        <col width="2.5%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.0%" />
        <col width="3.3%" />
        <col width="3%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.5%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.1%" />
        <col width="3.1%" />
        <col width="4.2%" />
        {/** nn mua */}
        <col width="3.5%"></col>
        {/** nn ban */}
        <col width="3.9%"></col>
      </colgroup>
      {children && <thead className="bb-1-haft ">{children}</thead>}
      <tbody>
        {resource &&
          !!resource.length &&
          resource.map((item, index) => {
            return (
              <DatagridRowGroupBond
                record={item}
                symbol={item}
                key={`${item.sym}-${index}`}
                isPc={isPc}
              />
            );
          })}
      </tbody>
    </table>
  );
}

const mapStateToProps = (state) => {
  return {
    symScroll: state.client.symbolScroll,
  };
};

export default connect(mapStateToProps)(DataGridGroupBond);
